import { APIURL } from "./config";
import { NOTIFICATIO_IMAGE } from "./config";
// import { DEVICE_TOKEN } from "./config";

import axios from "axios";
import { toast } from "react-toastify";
import {
  ORDER_LIST,
  ORDER_DELETE,
  ORDER_RECENT,
  ORDER_UPDATE,
  ORDER_RECENT_DELETE,
  ORDER_UPDATE_FLEET,
  ADD_NOTES,
  GET_ORDER_BY_ID,
  LOADING,
  NOT_FOUND,
} from "./type";
export const pushNotificationClient = (title, body, DEVICE_TOKEN) => {
  const token = localStorage.getItem("token");

  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    type: "staff",
    title: title,
    body: body,
    token: DEVICE_TOKEN,
    image: NOTIFICATIO_IMAGE,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(`${APIURL}/api/v1/order/client-notification`, requestOptions)
    .then((response) => response.json())
    .then((result) => console.log(result))
    .catch((error) => console.log("error", error));
};

export const ordersList =
  (page = 1, search = "", limit = 10, startDate = "", endDate = "", status = "") =>
  async (dispatch) => {
    dispatch({ type: LOADING, payload: {} });
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await axios.get(
        `${APIURL}/api/v1/order?page=${page}&search=${search}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&status=${status}`,
        config
      );
      const orderData = response.data.orders
        ? response.data.orders?.filter(
            (item) => item.status !== "order_initiated"
          )
        : [];
      dispatch({
        type: ORDER_LIST,
        payload: {
          orders: orderData,
          pagination: response.data.pagination,
        },
      });
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

export const ordersDelete = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    if (window.confirm("Do you want to delete order?")) {
      const response = await axios.delete(
        `${APIURL}/api/v1/order/${id}`,
        config
      );
      toast.success("Order Deleted Successfully!");
      dispatch({
        type: ORDER_DELETE,
        payload: response.data,
      });
      return response;
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const recentOrders = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get(
      `${APIURL}/api/v1/order/recent-order`,
      config
    );
    dispatch({
      type: ORDER_RECENT,
      payload: response.data,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const recentDelete = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    if (window.confirm("Do you want to delete order?")) {
      const res = await axios.delete(`${APIURL}/api/v1/order/${id}`, config);
      dispatch({
        type: ORDER_RECENT_DELETE,
        payload: res.data,
      });
      toast.success("Order Deleted Successfully!");
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const updateOrder = (val, id, stats) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    staff_id: val?.staff_id,
    staffs_id: val?.staff_id,
    staff_status: "staff_assigned",
    task_status: "staff_assigned",
  });
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/order/${id}`,
      body,
      config
    );

    dispatch({ type: ORDER_UPDATE, payload: response?.data });
    if (stats !== "true") {
      toast.success("Staff assigned successfully!");
      pushNotificationClient(
        "Staff assigned successfully!",
        "Fleet",
        response?.data?.data?.order?.customer_id?.device_token
      );
    }
    setTimeout(() => {
      return (window.location.href = `/edit-order/${id}`);
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const cancelOrder = (note, id, stats) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    cancel_note: note,
    status: stats,
  });
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/order/${id}`,
      body,
      config
    );

    dispatch({ type: ORDER_UPDATE, payload: response?.data });
    if (stats !== "true") {
      toast.success("Order cancelled!");
      pushNotificationClient(
        "Order cancelled!",
        "Order",
        response?.data?.data?.order?.customer_id?.device_token
      );
    }
    setTimeout(() => {
      return (window.location.href = `/orders`);
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
// export const addNoteToOrder = (val, id) => async (dispatch) => {
//   const token = localStorage.getItem("token");
//   var config = {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//   };
//   const body = JSON.stringify({
//     notes: val,
//   });
//   try {
//     const response = await axios.patch(
//       `${APIURL}/api/v1/order/${id}`,
//       body,
//       config
//     );

//     dispatch({ type: ORDER_UPDATE, payload: response?.data });
//     toast.success("Note added successfully!");
//     setTimeout(() => {
//       return (window.location.href = `/edit-order/${id}`);
//     }, 1000);
//   } catch (error) {
//     toast.error(error?.response?.data?.message);
//   }
// };
export const addNoteToOrder = (payload, callBack) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  let data = JSON.stringify({
    note: payload?.notes,
    order_id: payload?.orderId,
  });
  try {
    const response = await axios.post(`${APIURL}/api/v1/notes`, data, config);
    callBack("success");
    dispatch({ type: ADD_NOTES, payload: response?.data });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
export const updateOrderFleet = (val, id, stats) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    fleet_id: val?.fleet_id,
    fleet_status: "fleet_assigned",
  });
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/order/${id}`,
      body,
      config
    );
    dispatch({ type: ORDER_UPDATE_FLEET, payload: response?.data });
    if (stats !== "true") {
      toast.success("Fleet assigned successfully!");
      // pushNotificationClient(
      //   "A fleet assigned successfully to our staff!",
      //   "Our staff will reach at your location soon!",
      //   response?.data?.data?.order?.customer_id?.customer_device_token
      // );
      // pushNotificationClient(
      //   "A fleet assigned successfully to you!",
      //   "Customer is waiting please reach at his location soon!",
      //   response?.data?.data?.order?.customer_id?.staff_device_token
      // );
    } else {
      toast.success("Fleet and Staff assigned successfully!");
      // pushNotificationClient(
      //   "Fleet and Staff assigned successfully to you!",
      //   "Our staff will reach at your location soon!",
      //   response?.data?.data?.order?.customer_id?.customer_device_token
      // );
      // pushNotificationClient(
      //   "Fleet and Staff assigned successfully!",
      //   "Customer is waiting please reach at his location soon!",
      //   response?.data?.data?.order?.customer_id?.staff_device_token
      // );
    }

    // setTimeout(() => {
    //   return (window.location.href = `/edit-order/${id}`);
    // }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const multiOrderDelete = (id) => {
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow",
  };
  const label = id?.length > 1 ? "Orders" : "Order";
  if (window.confirm(`Do you want to delete the selected ${label.toLowerCase()}?`)) {
    fetch(`${APIURL}/api/v1/order/delete/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status == "success") {
          toast.success(`${label} Deleted Successfully!`);
        }
      })
      .catch((error) => console.log("error", error));
  }
};

//
export const getOrderById = (id) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: "",
  });
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(`${APIURL}/api/v1/order/${id}`, config)
    .then((response) => {
      // GET_ORDER_BY_ID
      dispatch({
        type: GET_ORDER_BY_ID,
        payload: response?.data,
      });
      // setViewDetails(response.data);
    })
    .catch((error) => console.log("error", error));
};
